class NSSPDPWhenToDrink extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][PDP When To Drink] Connected.");

    this.initCarousels();
    this.addEventListener("pdpUpdate", this.updateContent.bind(this));
  }

  updateContent(e) {
    if (this.debug) console.log("[NSS][PDP When To Drink] Updating...");
    const variantId = e.detail;
    const activeEls = this.querySelectorAll(`.nss-active`);
    activeEls.forEach((activeEl) => {
      activeEl.classList.remove(`nss-active`);
    });
    if (this.debug) console.log("[NSS][PDP When To Drink] variantId:", variantId);
    const contentEls = this.querySelectorAll(`[nss-variant-id="${variantId}"]`);
    contentEls.forEach((contentEl) => {
      contentEl.classList.add(`nss-active`);
    });

    // Update color scheme
    const prefix = "nss-scheme-";
    const classes = this.className.split(" ").filter(c => !c.startsWith(prefix));
    this.className = classes.join(" ").trim();
    this.classList.add(`nss-scheme-${variantId}`);
  }

  initCarousels() {
    const carouselEls = this.querySelectorAll(`.swiper`);

    carouselEls.forEach((carouselEl) => {
      const id = carouselEl.getAttribute(`nss-carousel-id`);
      const swiper = new Swiper(carouselEl, {
        loop: true,
        autoHeight: true,
        grabCursor: true,
        spaceBetween: 0,
  
        breakpoints: {
          414: {
            slidesPerView: 1.2,
            centeredSlides: true,
          },
          750: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 4,
            centeredSlides: false,
          },
        },
  
        a11y: {
          enabled: true,
        },
      
        navigation: {
          prevEl: `.nss-pdp-when-to-drink-prev-${id}`,
          nextEl: `.nss-pdp-when-to-drink-next-${id}`,
        },
  
        pagination: {
          el: `.nss-pdp-when-to-drink-pagination-${id}`,
          clickable: true,
        },
      });
    });
  }
}

let elementName = `nss-pdp-when-to-drink`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSPDPWhenToDrink);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}